/**
 * @typedef {import("./Props").default} Props
 */

import { translate } from 'App/Internationalization';
import BaseButton from 'shared/BaseButton/BaseButton';
import BaseForm from 'shared/Forms/BaseForm';
import FieldRadio from 'shared/Forms/Fields/FieldRadio';
import FilterGroup from '../Types/FilterGroup';
import React from 'react';

/** @extends	{React.Component<Props>} */
export default class AvmRequestFilter extends React.Component {
	/** @param {Props} props */
	constructor(props) {
		super(props);

		this.state = { active: false };

		this._handleSubmit = this._handleSubmit.bind(this);
		this._handleReset = this._handleReset.bind(this);
	}

	/** @param {{requested: 'yes' | 'no'}} value */
	_handleSubmit(value) {
		this.props.onSubmit({
			'filter[requested]': value.requested,
		});

		this.setState({ active: true });
	}

	_handleReset() {
		this.props.onSubmit({
			'filter[requested]': undefined,
		});

		this.setState({ active: false });
	}

	/** @returns {JSX.Element} */
	render() {
		return (
			<FilterGroup
				active={this.state.active}
				locked={this.props.gated}
				title={'Requested Valuation'}
			>
				<BaseForm noRequiredText={true} onSubmit={this._handleSubmit}>
					<div className="flex flex-col gap-4">
						<FieldRadio
							id="yes"
							label={'Yes'}
							name="requested"
							required={false}
							value={'yes'}
						/>
						<FieldRadio
							id="no"
							label={'No'}
							name="requested"
							required={false}
							value={'no'}
						/>

						<div className="flex gap-2">
							<BaseButton
								className="w-fit"
								iconSize="small"
								size="xsmall"
								type="submit"
							>
								{translate('filters.submit')}
							</BaseButton>
							<BaseButton
								className="w-fit"
								iconSize="small"
								onClick={this._handleReset}
								outline={true}
								size="xsmall"
								type="reset"
							>
								{translate('filters.reset')}
							</BaseButton>
						</div>
					</div>
				</BaseForm>
			</FilterGroup>
		);
	}
}
